import { SWRConfiguration } from 'swr';

import { apiClient, orchestratorClient } from './axiosConfig';

export const swrConfig: SWRConfiguration = {
  fetcher: (url: string) => apiClient.get(url).then((res) => res.data),
  onErrorRetry: (error, _key, _config, revalidate, { retryCount }) => {
    // Only retry up to 3 times.
    if (retryCount >= 3) { return error; }

    // Retry immediately.
    return revalidate({ retryCount });
  },
  revalidateOnFocus: false,
};

// Separate from the default `swrConfig` fetcher because orchestrator calls go through
// `orchestratorClient` rather than the cnuapp `apiClient`.
export const orchestratorFetcher = (url: string) => orchestratorClient.get(url).then((res) => res.data);
